import './CustomReadMoreContent.scss';

import React, {
  memo,
  useState,
} from 'react';

import { Typography } from 'antd';
import { ParagraphProps } from 'antd/lib/typography/Paragraph';
import ReactHtmlParser from 'html-react-parser';
import Linkify from 'react-linkify';

import { useTheme } from '../../context/ThemeProvider';
import { useLinesClampDetect } from '../../shared/hooks';

interface Props extends ParagraphProps {
  formatType?: 'text' | 'parsed';
  children: React.ReactNode;
  lines?: number;
  seeMoreText?: string;
  seeLessText?: string;
  expandable?: boolean;
}

const CustomReadMoreContent: React.FC<Props> = ({
  formatType = 'text',
  children,
  lines = 3,
  className = 'message',
  seeMoreText = 'See more',
  seeLessText = 'See less',
  // ellipsis,
  expandable = true,
  ...props
}) => {
  const { style, ...restProps } = props;

  const { colors: COLORS } = useTheme();

  const { ref, isClamped } = useLinesClampDetect(lines);

  const [isExpanded, setIsExpanded] = useState(false);

  const formatContent = (content: React.ReactNode) => {
    if (formatType === 'parsed' && typeof content === 'string') {
      // return ReactHtmlParser(content.replaceAll('\n', '<br>'));
      return ReactHtmlParser(content);
    }

    return content;
  };

  return (
    <Linkify>
      <Typography.Paragraph
        className={`custom-read-more-content ${className}`}
        style={{
          whiteSpace: formatType === 'text' ? 'pre-wrap' : undefined,
          marginBottom: 0,
          ...style,
        }}
        {...restProps}>
        <div
          ref={ref}
          className="custom-read-more-content__text"
          style={{
            position: 'relative',
            overflow: isExpanded ? 'visible' : 'hidden',
            display: '-webkit-box',
            WebkitLineClamp: isExpanded ? 'unset' : lines,
            WebkitBoxOrient: 'vertical',
            whiteSpace: formatType === 'text' ? 'pre-wrap' : undefined,
          }}>
          {formatContent(children)}
        </div>

        {expandable && (isClamped || isExpanded) ? (
          <Typography.Text
            style={{
              display: 'inline-block',
              fontWeight: 600,
              color: COLORS.LINK,
              cursor: 'pointer',
            }}
            onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? seeLessText : seeMoreText}
          </Typography.Text>
        ) : null}
      </Typography.Paragraph>
    </Linkify>
  );
};

export default memo(CustomReadMoreContent);
